/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for parameterLocationType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="parameterLocationType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="request"/&gt; &lt;enumeration value="query"/&gt; &lt;enumeration value="global"/&gt; &lt;enumeration value="module"/&gt; &lt;enumeration value="datasource"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ParameterLocationType extends Enum{

	enumValue = null;

	static  REQUEST = ParameterLocationType.newLiteral("request");

	static  QUERY = ParameterLocationType.newLiteral("query");

	static  GLOBAL = ParameterLocationType.newLiteral("global");

	static  MODULE = ParameterLocationType.newLiteral("module");

	static  DATASOURCE = ParameterLocationType.newLiteral("datasource");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ParameterLocationType.values().length); ++i) {
			if (ParameterLocationType.values()[i].enumValue == v) {
				return ParameterLocationType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ParameterLocationType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterLocationType.js